import { Pipe, PipeTransform } from '@angular/core';
import { CropService } from './../../common/_services/crop.service';
@Pipe({
  name: 'datacrop',
  pure: true,
  standalone: false,
})
export class DatacropPipe implements PipeTransform {
  constructor(private cropService: CropService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.cropService.getCropById(Number(value));
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
